import { render, staticRenderFns } from "./TaskTimeLogger.vue?vue&type=template&id=485a9ffc&scoped=true&"
import script from "./TaskTimeLogger.vue?vue&type=script&lang=js&"
export * from "./TaskTimeLogger.vue?vue&type=script&lang=js&"
import style0 from "./TaskTimeLogger.vue?vue&type=style&index=0&id=485a9ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a9ffc",
  null
  
)

export default component.exports